import { useQueryClient } from '@tanstack/react-query'
import { createConnectQueryKey, useMutation, useTransport } from '@connectrpc/connect-query'

import {
  addEventAddon,
  getEventPackingList,
  listEventAddons,
  listJobEvents,
  removeEventAddon,
  restoreEventAddon,
} from '@/gen/cortado/v1/cortado-CortadoService_connectquery'

/**
 * Adds, removes and restores the event's add-ons. Only the event changes, never
 * the quote. Each refetches the add-on list, the packing list (it packs the
 * add-ons and shows a stale notice when they change) and the job's Logistics
 * readiness.
 */
export function useEventAddonMutations(eventId: string) {
  const queryClient = useQueryClient()
  const transport = useTransport()

  const refresh = () =>
    Promise.all([
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({ schema: listEventAddons, transport, input: { eventId }, cardinality: 'finite' }),
      }),
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({ schema: getEventPackingList, transport, input: { eventId }, cardinality: 'finite' }),
      }),
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({ schema: listJobEvents, transport, cardinality: undefined }),
      }),
    ])

  const add = useMutation(addEventAddon, { onSuccess: refresh })
  const remove = useMutation(removeEventAddon, { onSuccess: refresh })
  const restore = useMutation(restoreEventAddon, { onSuccess: refresh })

  return { add, remove, restore }
}
